module.exports = __webpack_public_path__ + "img/public.f4285637.png";